import {
  httpGet
} from '../hook/request.js'
import {
  initDemoDatas,
  initDatas
} from '../hook/common.js'
import AlertMsg from '@/components/AlertMsg.vue'
const mixin = {
  components: {
    'K-AlertMsg': AlertMsg,
  },
  data() {
    return {
      code: null,
      verify: null,
      datas: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      },
      AlertMsg: {
        state: false,
        name: '温馨提示',
        msg: null,
      }
    }
  },
  created() {
    this.code = this.GetCode(); //二维码提取
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    PreviewImgs() {
      this.$viewer.show();
      this.$viewer.update();
    },
    AlertBack(e) { //弹窗确定
      this.AlertMsg.state = e;
    },
    ViewMore(etype) { //扫码记录
      localStorage.setItem("wwm_etype", etype);
      if (this.code) {
        this.$router.push({
          path: "/ScanCodeRecord"
        }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    ClickMenu(data) { //菜单跳转
      const defaultURL = "http://oid.plus";
      if (data.type != 2) {
        window.location.href = data.url || defaultURL;
      } else {
        this.$router.push({
          path: "/qr?qr=" + data.qr
        });
      }
    },
    initVideo() {
      //初始化视频方法
      this.$video(VideoBox, {
        controls: true, //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false, //自动播放属性,muted:静音播放
        preload: "auto", //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    async GetDemoDatas(pid, rid) { //获取演示数据
      try {
        const res = await httpGet({
          url: `template_product/${pid}/${rid}/`
        });
        if (res && res.code === 200) {
          this.datas = initDemoDatas(res); //返回数据赋值
          console.log(this.datas);
        }
      } catch (e) {
        this.Loading.type = 3;
        this.Loading.txt = this.ErrorHint(e);
      }
    },
    async GetDatas(callback) {
      try {
        const res = await httpGet({
          url: `query/${this.code}`
        });
        if (res && res.code === 200) {
          this.datas = initDatas(res); //返回数据赋值
          if(this.datas.video && this.datas.video_is_show){
            setTimeout(() => {
              this.initVideo();
            });
          }
          callback && callback();
        }
      } catch (e) {
        console.log(e)
        this.Loading.type = 3;
        this.Loading.txt = this.ErrorHint(e);
      }
    },
    setFormContent(formItem, obj) { //设置表单内容
      if (Object.prototype.toString.call(formItem) !== '[object Object]' || Object.prototype.toString.call(obj) !==
        '[object Object]') {
        return
      };
      Object.keys(formItem).forEach(formKey => {
        Object.keys(obj).forEach(objKey => {
          if (formKey === objKey) { //判断两个对象的key是否一致
            formItem[formKey].value = obj[objKey];
          }
        })
      })
    }
  }
}
export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/mixin.js